<template >
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
<style>
* {
  padding: 0;
  margin: 0
}
</style>



// WEBPACK FOOTER //
// App.vue?507e363e